import createListing from "../create-listing/create-listing";
import firebase from "../firebase";
import allHandeling from "../handeling-all-displays/all-handeling";
import yourListings from "../main-menu/your-listings";
import spinner from "../spinner";
import DisplayBusinessOwn from "../business-page-own-veiw/busine-own";

const PopOverActionsMenuCon1 = document.getElementById(
  "PopOverActionsMenuCon1"
);
class ownListings {
  #listingId;
  #e;
  #businessId;
  constructor() {
    // this._events();
    this._initEditOptionsDrag()
    this._editOptionsEvents()
  }
  _openPopOver(option, businessId, listingId, e, deleteOnly) {
    this.#listingId = listingId
    this.#businessId = businessId
    this._handelEditOptinsShow(true, deleteOnly)
  }
  // _closePopOver() {
  // }

  // call this to show/hide the sheet
  _handelEditOptinsShow(open, deleteOnly = false) {
    const NVEditOptionsEditListing = document.getElementById('NVEditOptionsEditListing');
    const NVEditOptions = document.getElementById('NVEditOptionsListing');
    if (!NVEditOptions) return;

    if (NVEditOptionsEditListing) {
      if (deleteOnly) {
        NVEditOptionsEditListing.style.display = 'none'
      } else {
        NVEditOptionsEditListing.style.display = 'flex'
      }
    }

    const sheet = NVEditOptions.querySelector('.nvEditOptionsCon1');
    if (!sheet) return;

    // Ensure transition style is set once
    sheet.style.transition = 'transform 0.35s ease, opacity 0.35s ease';

    if (open) {
      // Make container visible first
      NVEditOptions.style.display = 'flex';
      NVEditOptions.style.pointerEvents = 'auto';
      sheet.style.pointerEvents = 'auto';

      // Start from off-screen
      sheet.style.transform = 'translateY(100%)';
      sheet.style.opacity = '0';

      // Animate in on the next frame
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          sheet.style.transform = 'translateY(0)';
          sheet.style.opacity = '1';
        });
      });
    } else {
      // Animate out
      sheet.style.transform = 'translateY(100%)';
      sheet.style.opacity = '0';
      sheet.style.pointerEvents = 'none';
      NVEditOptions.style.pointerEvents = 'none';

      // After transition, hide completely
      const cleanup = () => {
        NVEditOptions.style.display = 'none';
        sheet.removeEventListener('transitionend', cleanup);
      };

      sheet.addEventListener('transitionend', cleanup);

      // Fallback timeout in case transitionend doesn’t fire
      setTimeout(cleanup, 350);
    }
  }

  _initEditOptionsDrag() {
    const NVEditOptions = document.getElementById('NVEditOptionsListing');
    if (!NVEditOptions) return;
    const sheet = NVEditOptions.querySelector('.nvEditOptionsCon1');
    const handle = NVEditOptions.querySelector('#NVEditOptionsHideBarListing');

    if (!sheet || !handle) return;

    // Prevent duplicate listener setup
    if (this.__nvEditOptionsDragInit) return;
    this.__nvEditOptionsDragInit = true;

    let startY = 0;
    let currentY = 0;
    let lastY = 0;
    let lastTime = 0;
    let dragging = false;
    let velocity = 0;

    const originalTransition =
      getComputedStyle(sheet).transition || 'transform 0.35s ease, opacity 0.35s ease';

    const startDrag = (e) => {
      if (NVEditOptions.style.display === 'none' || NVEditOptions.style.display === '') return;

      dragging = true;
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;
      startY = clientY;
      currentY = clientY;
      lastY = clientY;
      lastTime = performance.now();

      sheet.style.transition = 'none';
      sheet.style.willChange = 'transform, opacity';
    };

    const onDrag = (e) => {
      if (!dragging) return;

      const clientY = e.touches ? e.touches[0].clientY : e.clientY;
      const diff = Math.max(0, clientY - startY);
      currentY = clientY;

      // velocity calculation
      const now = performance.now();
      const deltaTime = now - lastTime;
      velocity = (clientY - lastY) / deltaTime;
      lastY = clientY;
      lastTime = now;

      sheet.style.transform = `translateY(${diff}px)`;
      sheet.style.opacity = `${Math.max(0.3, 1 - diff / 300)}`;
    };

    const endDrag = () => {
      if (!dragging) return;
      dragging = false;
      sheet.style.transition = originalTransition;
      sheet.style.willChange = '';

      const diff = currentY - startY;
      const dismissThreshold = 120;
      const velocityThreshold = 0.6;

      if (diff > dismissThreshold || velocity > velocityThreshold) {
        // dismiss
        sheet.style.transform = 'translateY(100%)';
        sheet.style.opacity = '0';
        this._handelEditOptinsShow(false)
      } else {
        // snap back
        sheet.style.transform = 'translateY(0)';
        sheet.style.opacity = '1';
      }
    };

    // === Event Listeners ===
    const dragTargets = [sheet, handle, NVEditOptions];
    dragTargets.forEach((el) => {
      el.addEventListener('touchstart', startDrag, { passive: true });
      el.addEventListener('mousedown', (ev) => {
        ev.preventDefault();
        startDrag(ev);
      });
    });

    window.addEventListener('touchmove', onDrag, { passive: true });
    window.addEventListener('mousemove', onDrag);
    window.addEventListener('touchend', endDrag);
    window.addEventListener('mouseup', endDrag);

    // Close when tapping backdrop (outside sheet)
    NVEditOptions.addEventListener('click', (ev) => {
      // Only close if clicked outside the sheet
      if (ev.target === NVEditOptions) {
        this._handelEditOptinsShow(false);
      }
    });
  }

  // _shareListing() {
  //   console.log(this.#e.target);
  //   let openTo = "listing";
  //   if (this.#businessId && this.#businessId !== "undefined") {
  //     openTo = "listingInBusiness";
  //   }
  //   allHandeling._displayTheRightWay(
  //     this.#businessId,
  //     this.#listingId,
  //     openTo,
  //     null,
  //     true
  //   );
  //   this._closePopOver();
  //   yourListings._close();
  // }
  // _boostListing() {
  //   alert("Proximamente. Esta funcion aún no está lista.");
  // }

  async _editCurrentListing() {
    const account = firebase._getLatestCurrentUserData();
    console.log("here");
    let path = `accounts/${account.userId}/listings/${this.#listingId}`;
    // let path = `listings/${this.#listingId}`;
    console.log(path);
    console.log(this.#businessId, this.#listingId);
    if (this.#businessId && this.#businessId !== "undefined") {
      path = `businesses/${this.#businessId}/listings/${this.#listingId}`;
    }
    spinner._displaySpinner("Cargando listado...");
    console.log(path);
    const data = await firebase._getAnyDocById(path);
    console.log(data);
    if (!data || data.length < 1) {
      alert("Hubo un error. Intenta de nuevo mas tarde.");
      spinner._hideSpinner();
      return;
    }
    createListing._init(data);
    spinner._hideSpinner();
    this._handelEditOptinsShow(false)
  }


  async _deleteCurrentListing() {
    try {

      const account = firebase._getLatestCurrentUserData()


      let lives = 'seller';
      let parentId = account.userId;
      let listingId = this.#listingId;

      if (this.#businessId && this.#businessId !== "undefined") {
        lives = 'business';
        parentId = this.#businessId;
      }

      const confirmDelete = confirm(
        "¿Estas seguro que quieres eliminar este listado?"
      );
      if (!confirmDelete) {
        return;
      }

      spinner._displaySpinner("Eliminando listado...");

      const deleteResult = await firebase._NVDeleteListing({ lives, parentId, listingId });
      if (deleteResult.data.status === "success") {
        alert("Listado eliminado con éxito.");

        allHandeling._actionsOnListingInEditElement('remove');


        // DisplayBusinessOwn._init();
      }
      if (deleteResult.data.status === "error") {
        alert(`Ocurio un error: ${deleteResult.data.message}`);
      }
    } catch (error) {

    } finally {
      spinner._hideSpinner();
      this._handelEditOptinsShow(false)
    }

  }

  _editOptionsEvents() {
    const NVEditOptionsEdit = document.getElementById('NVEditOptionsEditListing')
    const NVEditOptionsDelete = document.getElementById('NVEditOptionsDeleteListing')
    const NVEditOptionsHideBarListing = document.getElementById('NVEditOptionsHideBarListing')
    NVEditOptionsEdit.addEventListener('click', () => {
      this._editCurrentListing()
    })
    NVEditOptionsDelete.addEventListener('click', () => {
      this._deleteCurrentListing()
    })
    NVEditOptionsHideBarListing.addEventListener('click', () => {
      this._handelEditOptinsShow(false)
    })
  }

  // async _onAction(action) {
  //   console.log(action);

  //   if (action === "close") {
  //     this._closePopOver();
  //   }
  //   if (action === "share") {
  //     this._shareListing();
  //   }
  //   if (action === "boost") {
  //     this._boostListing();
  //   }
  //   if (action === "open") {
  //     let openTo = "listing";
  //     if (this.#businessId && this.#businessId !== "undefined") {
  //       openTo = "listingInBusiness";
  //     }
  //     allHandeling._displayTheRightWay(
  //       this.#businessId,
  //       this.#listingId,
  //       openTo
  //     );
  //     this._closePopOver();
  //     yourListings._close();
  //   }
  //   if (action === "edit") {
  //     let path = `listings/${this.#listingId}`;
  //     console.log(path);
  //     if (this.#businessId && this.#businessId !== "undefined") {
  //       path = `businesses/${this.#businessId}/listings/${this.#listingId}`;
  //     }
  //     spinner._displaySpinner("Cargando listado...");
  //     console.log(path);
  //     const data = await firebase._getAnyDocById(path);
  //     console.log(data);
  //     if (!data || data.length < 1) {
  //       alert("Hubo un error. Intenta de nuevo mas tarde.");
  //       spinner._hideSpinner();
  //       return;
  //     }
  //     createListing._init(data);
  //     spinner._hideSpinner();
  //     this._closePopOver();
  //   }
  //   if (action === "delete") {
  //     let path = `listings/${this.#listingId}`;
  //     console.log(path);
  //     if (this.#businessId && this.#businessId !== "undefined") {
  //       path = `businesses/${this.#businessId}/listings/${this.#listingId}`;
  //     }
  //     console.log(path);

  //     const confirmDelete = confirm(
  //       "¿Estas seguro que quieres eliminar este listado?"
  //     );
  //     if (!confirmDelete) {
  //       return;
  //     }
  //     spinner._displaySpinner("Cargando listado...");

  //     const deleteResult = await firebase._deleteListing({ path: path });
  //     if (deleteResult.data.status === "success") {
  //       alert("Listado eliminado con éxito.");
  //       DisplayBusinessOwn._init();
  //     }
  //     if (deleteResult.data.status === "error") {
  //       alert(`Ocurio un error: ${deleteResult.data.message}`);
  //     }
  //     spinner._hideSpinner();
  //     this._closePopOver();
  //   }
  // }

  // _events() {
  //   PopOverActionsMenuCon1.addEventListener("click", (e) => {
  //     console.log("clicked");
  //     const action = e.target.closest(".PopOverActionsMenuActionOption").dataset
  //       .action;
  //     console.log(action);
  //     if (action) {
  //       this._onAction(action);
  //     }
  //   });
  // }
}

export default new ownListings();
